import { render, staticRenderFns } from "./additional-travellers-combined-products-modal.vue?vue&type=template&id=c618a0be&scoped=true"
import script from "./additional-travellers-combined-products-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./additional-travellers-combined-products-modal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./additional-travellers-combined-products-modal.vue?vue&type=style&index=0&id=c618a0be&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c618a0be",
  null
  
)

export default component.exports